import { useEffect } from "react";
import wrapperStyles from "../../../styles/UI/wrappers.module.css";

export default function MainContentWrapper({
  children,
  classes,
  selectedTab,
  firstTab,
}: {
  children: React.ReactNode | React.ReactNode[];
  classes?: string;
  selectedTab: string;
  firstTab: string;
}) {
  const classList = `${wrapperStyles.mainContentWrapper}  ${classes ? classes : null}`;
  return (
    <article
      className={classList}
      style={{
        borderRadius: ` ${selectedTab === firstTab ? "0 var(--border-radius-minimal) 0 0" : "var(--border-radius-minimal) var(--border-radius-minimal) 0 0"}`,
      }}
    >
      {children}
    </article>
  );
}
